import { baseApi } from './baseApi';

export const cryptoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCryptoCurrencies: builder.query({
      query: () => '/crypto-currency',
      providesTags: ['CryptoCurrencies'],
    }),
    getCryptoCurrencyById: builder.query({
      query: (id) => `/crypto-currency/${id}`,
      providesTags: (result, error, id) => [{ type: 'CryptoCurrency', id }],
    }),
    getCryptoCurrencyBySymbol: builder.query({
      query: (symbol) => `/crypto-currency/symbol/${symbol}`,
      providesTags: (result, error, symbol) => [{ type: 'CryptoCurrency', id: symbol }],
    }),
    refreshCryptoData: builder.mutation({
      query: (cryptoCurrencyId) => ({
        url: `/crypto-currency/${cryptoCurrencyId}/refresh`,
        method: 'GET',
      }),
      invalidatesTags: (result, error, cryptoCurrencyId) => [
        { type: 'CryptoCurrency', id: cryptoCurrencyId },
        'CryptoCurrencies',
      ],
    }),
  }),
  overrideExisting: false,
});


